import { AlertCircle, CheckCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation , Link} from "react-router-dom";
import BuilderService from "../../services/BuilderService";
import { toast } from "react-toastify"
import { useTheme } from '../../../redux/hooks/useTheme';
import { motion, Variants } from 'motion/react';
import Logo from "../Dashboard/SubComponents/Logo";

export default function VerifyEmail() {
  const [verificationStatus, setVerificationStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [verifiedMail, setVerifiedMail] =  useState(null);
  const { token } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const builderService = new BuilderService();
  const { theme } = useTheme();

  useEffect(() => {
    if (token) {
      const basePath = location.pathname.replace(`/${token}`, '');
      window.history.replaceState({}, document.title, basePath);
    }
    
    verifyEmailToken()
  }, [token, location.pathname])

  const verifyEmailToken = async () => {
    if (!token) {
      setVerificationStatus('error')
      return
    }

    try {
      const response = await builderService.verifyEmailToken(token,'setPassword')
      if (response.success) {
        setVerificationStatus('success')
        setVerifiedMail(response.email);
        toast.success('Email verified successfully!')
      } else {
        setVerificationStatus('error');
        setVerifiedMail(null);
        toast.error(response.message || 'Verification failed')
      }
    } catch (error) {
      setVerificationStatus('error');
      setVerifiedMail(null);
      toast.error('Email verification failed')
    }
  }

 

  const handleCreatePassword = () => {
  if(verifiedMail)
    navigate(`/createPassword?email=${encodeURIComponent(verifiedMail)}`);
}

  if (verificationStatus === 'loading') {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500"></div>
      </div>
    )
  }

  return (
    <div
    style={{
      background: `url(${theme.heroSectionImage}) no-repeat`,
      backgroundColor: theme.heroSectionBackgroundGradient,
      backgroundSize:'cover',
      backgroundPosition:'center',
      backgroundRepeat:'no-repeat'
    }}
    className="flex flex-col md:flex-row gap-8 p-4 items-center justify-center min-h-screen">
      {verificationStatus === 'error' ? (
        <div className="w-full gap-[76px] max-w-md flex flex-col rounded-xl">
          <motion.div
                className="flex items-center justify-center mt-[-140px] sm:w-auto logo-mob"
              >
                <Link to="/">
                {/* <img
                  src={theme.heroLogo} // Use src instead of background
                  className="h-10 mr-2 md:p-0"
                  alt="Advance To Builder"
                />   */}
                <Logo />
                </Link>
              </motion.div>
          <div className="flex flex-col items-center p-8 text-center">
            <div className="w-[78px] h-[93px]  rounded-full flex items-center justify-center mb-[24px]">
              <div className="w-[78px] h-[93px]  rounded-md flex items-center justify-center relative">
                <div className="w-[78px] h-[93px]  rounded-t-md"></div>
                <div className="absolute -top-1 -right-1">
                  <img src="https://dlvkyia8i4zmz.cloudfront.net/tool_builder/1743010360416_Frame.png" alt="" />
                </div>
              </div>
            </div>
            <h2  style={{color:theme.faqQues, fontWeight:600}} className="text-[26px] font-sora font-bold mb-[10px]">Oops! Your Link Has Expired</h2>
            <p style={{fontWeight:400}} className="text-[18px] font-inter signup-hm">
            The verification link has expired. Request a new one to complete your sign-up.
            </p>
            <button 
              onClick={()=>{navigate('/login')}}
              className="w-[170px] mt-[32px] font-inter sign-upbt py-[14px] px-4 text-white font-medium rounded-[12px] transition-colors"
            >
             Go to Sign Up
            </button>
          </div>
        </div>
      ) : (
        <div className="w-full max-w-[528px] rounded-xl">
          <div className="flex flex-col items-center p-8 gap-[60px] text-center">
          <motion.div
                className="flex items-center w-[132px] mt-[-192px] sm:w-auto logo-mob"
              >
                <Link to="/">
                {/* <img
                  src={theme.heroLogo} // Use src instead of background
                  className="h-10 mr-2 md:p-0"
                  alt="Advance To Builder"
                />   */}
                <Logo />
                </Link>
              </motion.div>
          <div style={{alignItems:'center'}} className="flex flex-col justify-center  item-center">
          <div className="w-[78px] h-[93px]  rounded-full flex items-center justify-center mb-4">
              <div className="w-[78px] h-[93px] rounded-md flex items-center justify-center relative">
                <div className="w-[78px] h-[93px]  rounded-t-md"></div>
                <div className="absolute -top-1 -right-1">
                  <img src="https://dlvkyia8i4zmz.cloudfront.net/tool_builder/1743010655417_Frame__1_.png" alt="" />
                </div>
              </div>
            </div>
            <h2 style={{ color: theme.mainHeadingOne, fontWeight:600 }} className="text-[26px] font-sora">Email Verified Successfully!</h2>
            <p style={{color:theme.SubHeadingSubTwo,fontWeight:400}} className="text-[16px] mt-[10px] font-inter">
              Your email is verified. Now, set up your password to secure your account.
            </p>
            <button 
              onClick={handleCreatePassword}
              className="mt-[32px] font-inter sign-upbt py-[14px] px-4 text-white font-medium rounded-[12px] transition-colors"
            >
              Create New Password
            </button>
          </div>
          </div>
        </div>
      )} 
    </div>
  )
}